<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title" *ngIf="!inEditMode">{{ customerNote.title }}</h4>
    <h4 class="modal-title" *ngIf="inEditMode">Edit Customer Note</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="!inEditMode">
    <p style="white-space: pre-wrap">{{ customerNote.note }}</p>
  </div>

  <div class="modal-body" *ngIf="inEditMode">
    <div class="form-group">
      <label for="titleInput">Title *</label>
      <input type="text" class="form-control" id="titleInput" name="title" required
             [(ngModel)]="customerNote.title">
      <div class="form-text text-danger">{{ errors.title }}</div>
    </div>
    <div class="form-group">
      <label for="noteTextarea">Note *</label>
      <textarea class="form-control" id="noteTextarea" name="note" required
                [(ngModel)]="customerNote.note"></textarea>
      <div class="form-text text-danger">{{ errors.note }}</div>
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer" *ngIf="!inEditMode">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Back
    </button>
    <button type="button" class="btn btn-primary"
            (click)="inEditMode = true">
      Edit
    </button>
  </div>

  <div class="modal-footer" *ngIf="inEditMode">
    <button type="button" class="btn btn-danger"
            *ngIf="!loadingSubmit"
            (click)="handleRemove()">
      Remove
    </button>
    <button type="button" class="btn btn-danger disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingSubmit"
            (click)="handleSaveEdit()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
